import { Observable } from 'rxjs/Observable';
import { Injectable } from '@angular/core';

@Injectable()
export class CaptchaService {

    private captchaSiteKey = '';

    initialize(key: string = '') {
        this.captchaSiteKey = key;
        const script = (<any> window).document.getElementById('google-recaptcha-id');
        // check if script is existing
        if (!script) {
            const reCaptchaScript = (<any> window).document.createElement('script');
            reCaptchaScript.id = 'google-recaptcha-id';
            reCaptchaScript.type = 'text/javascript',
            reCaptchaScript.src = 'https://www.google.com/recaptcha/api.js?render=' + this.captchaSiteKey;
            reCaptchaScript.async = true;
            reCaptchaScript.defer = true;
            
            // append on head
            (<any> window).document.getElementsByTagName('head')[0].appendChild(reCaptchaScript);
        }
    }

    execute(action: string) {
        return new Observable<any>(
            observer => {
                try {
                    (<any> window).grecaptcha.ready(() => {
                        (<any> window).grecaptcha.execute(this.captchaSiteKey, {
                            action: action
                        }).then((token) => {
                            // send out token to included in request
                            observer.next(token);
                        });
                    });
                } catch (error) {
                    observer.error(error);
                }
            }
        );
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/services/captcha.service.ts